import { IPhone } from '../../store/similar';

export const mapPhoneToString = (phone: IPhone) => {
  return `${phone.countryCode}${phone.number}`;
};

export const isValidPhone = (phone: IPhone) => Boolean(phone.countryCode && phone.number);
